import { appSettings } from '@visalex/configs';

import isDate from 'date-fns/isDate';
import parse from 'date-fns/parse';

export function parseDate(inputValue: string, format = appSettings.dateFormat) {
  const parsed = parse(inputValue, format, new Date());

  if (isDate(parsed)) {
    return parsed;
  }

  return undefined;
}
